import { SuperTeamLeaderboardTeamsPage } from "@fwa/src/components/SuperTeamLeaderboardPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <SuperTeamLeaderboardTeamsPage memberType="page" />
  </>
);

export default Page;
